module.exports = __webpack_public_path__ + "static/media/snowball-ben.f7d3d58a.mov";